import { render, staticRenderFns } from "./input-cfpsid.vue?vue&type=template&id=55a1378b"
import script from "./input-cfpsid.vue?vue&type=script&lang=js"
export * from "./input-cfpsid.vue?vue&type=script&lang=js"
import style0 from "./input-cfpsid.vue?vue&type=style&index=0&id=55a1378b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../@coac/client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports